<script>
export default {
  name: "UiSpinner",
  props: {
    size: {
      type: String,
      default: "md", // sm, md, lg
    },
  },
  computed: {
    classSize: function () {
      var map = {
        sm: "spinner-border-sm",
        lg: "spinner-border-lg",
      };
      return map[this.size] || "";
    },
  },
};
</script>
<template>
  <div class="spinner-border text-secondary" :class="classSize" role="status">
    <span class="sr-only">{{ $t("global.loading") }}</span>
  </div>
</template>
